import ArticleLayoutsEnum from '@models/enums/ArticleLayoutsEnum';
import PostTypes from '@models/enums/PostTypes';
import { IArticle } from '@models/IArticle';
import { IListingCardBlock } from '@models/IListings';
import { ISearchResult } from '@models/ISearchResult';
import ArticleCard from '@molecules/ArticleCard/ArticleCard';
import SearchResultsCard from '@molecules/SearchResultCard/SearchResultCard';
import useRefocus from '@utils/hooks/useRefocus';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

const ListingCardBlock = (props: IListingCardBlock) => {
  const { results, type, layoutType, pageSize = 12, pageNumber = 0 } = props;
  const [classArray, setClassArray] = useState<string[]>([]);
  const placeholderRef = useRefocus(results);
  const placeIndex = pageNumber * pageSize;

  useEffect(() => {
    const layoutArrays = {
      [ArticleLayoutsEnum.ONE]: [1],
      [ArticleLayoutsEnum.ONE_TWO]: [1, 2],
      [ArticleLayoutsEnum.TWO]: [2],
      [ArticleLayoutsEnum.TWO_TWO]: [2, 2],
      [ArticleLayoutsEnum.THREE]: [3, 3, 3, 3],
      [ArticleLayoutsEnum.THREE_TWO_THREE]: [3, 2, 3, 2],
      [ArticleLayoutsEnum.THREE_TWO_TWO]: [3, 2, 2],
    };

    const generateClassArray = (template: Array<number>): Array<string> => {
      let res: string[] = [];
      const classes = [
        'col-span-full',
        layoutType === ArticleLayoutsEnum.THREE_TWO_THREE ||
        layoutType === ArticleLayoutsEnum.THREE_TWO_TWO
          ? 'col-span-6'
          : 'col-span-5',
        'col-span-4',
      ];

      template.forEach((row: number) => {
        const rowClasses = new Array(row).fill(classes[row - 1]);
        res = [...res, ...rowClasses];
      });

      return res;
    };
    setClassArray(generateClassArray(layoutArrays[layoutType]));
  }, [layoutType]);

  return (
    <div className="w-full" data-testid="listingCardBlockPrimary">
      <div
        className={classNames(
          'flex flex-col gap-x-0 gap-y-9 dark:text-white md:gap-x-4 md:gap-y-20 lg:grid',
          layoutType === ArticleLayoutsEnum.ONE ||
            layoutType === ArticleLayoutsEnum.ONE_TWO ||
            layoutType === ArticleLayoutsEnum.TWO ||
            layoutType === ArticleLayoutsEnum.TWO_TWO
            ? 'lg:grid-cols-10'
            : 'lg:grid-cols-12'
        )}
        data-testid="listingCardBlockGridWrapper"
      >
        {results?.map((item, index) => {
          const id = `${item.title}-${index}`;

          return (
            <div
              className={classArray[index % pageSize]}
              key={`article-${id}`}
              tabIndex={-1}
              ref={
                placeIndex > 0 && placeIndex === index ? placeholderRef : null
              }
              data-testid={`Article-Listing-Item-${index}`}
            >
              {type === PostTypes.SEARCH ? (
                <SearchResultsCard {...(item as ISearchResult)} />
              ) : (
                <ArticleCard layoutType={layoutType} {...(item as IArticle)} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListingCardBlock;
